import { render } from "./MessageFilter.vue?vue&type=template&id=882185ca&scoped=true&ts=true"
import script from "./MessageFilter.vue?vue&type=script&lang=ts"
export * from "./MessageFilter.vue?vue&type=script&lang=ts"

import "./MessageFilter.vue?vue&type=style&index=0&id=882185ca&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-882185ca"]])

export default __exports__